export default __webpack_public_path__ + "static/phoneOpenBanking-4451ebb76fcc7d9abc57c5079f5d19bb.png";